<template>
  <div>
    <h2 class="section-title">Funcionalidades pensadas para o cuidado acontecer</h2>
    <p class="section-subtitle">
      Cada módulo existe para eliminar pontos de atrito: o agendamento, o financeiro, a comunicação e a rotina do
      atendimento.
    </p>

    <div class="features">
      <div class="feature card">
        <div class="f-icon" aria-hidden="true">📅</div>
        <h3 class="f-title">Agenda inteligente</h3>
        <p class="f-text">Controle de atendimentos com previsibilidade para o time e para o responsável.</p>
      </div>

      <div class="feature card">
        <div class="f-icon" aria-hidden="true">📊</div>
        <h3 class="f-title">Dashboard financeiro</h3>
        <p class="f-text">Acompanhe entradas, contas e convênios com clareza operacional.</p>
      </div>

      <div class="feature card">
        <div class="f-icon" aria-hidden="true">👨‍👩‍👧‍👦</div>
        <h3 class="f-title">Portal do responsável</h3>
        <p class="f-text">Mais segurança e menos dúvidas repetidas no dia a dia da clínica.</p>
      </div>

      <div class="feature card">
        <div class="f-icon" aria-hidden="true">📺</div>
        <h3 class="f-title">Chamada de pacientes na TV</h3>
        <p class="f-text">Fluxo mais organizado na recepção, reduzindo interrupções e filas.</p>
      </div>

      <div class="feature card">
        <div class="f-icon" aria-hidden="true">🧾</div>
        <h3 class="f-title">Controle de atendimentos</h3>
        <p class="f-text">Registros consistentes e rotina mais estável do início ao fim do atendimento.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default { name: 'FeaturesSection' }
</script>

<style scoped>
.features {
  margin-top: 22px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
}

.feature {
  padding: 18px;
}

.f-icon {
  width: 46px;
  height: 46px;
  border-radius: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(77, 186, 135, 0.12);
  font-size: 18px;
}

.f-title {
  margin: 14px 0 6px;
  font-weight: 900;
  font-size: 16px;
}

.f-text {
  margin: 0;
  color: var(--easy-muted);
  line-height: 1.55;
  font-size: 14px;
}

@media (max-width: 980px) {
  .features {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 560px) {
  .features {
    grid-template-columns: 1fr;
  }
}
</style>
